//@vendor
const Immutable = require('immutable');
const { handleActions } = require('redux-actions');
const get = require('lodash/object/get');

//@actions
const { simpleActions } = require('../../actions/contractPreGrantedCredit');

//@constants
const { FIRST_STEP, SECOND_STEP, WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP } = require('constants/index');
const { MIN_VALUE_REQUEST_AMOUNT } = require('../../loansConstants/index').preGrantedCredit;
const { EURO_TEXT } = require('constants/index');

// @helpers
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');

const setInitialState = () => Immutable.fromJS({
    steps: [
        { valid: false },
        { valid: false },
        { hasSignaturePattern: true }
    ],
    fourSteps: [
        { valid: false },
        { valid: false },
        { valid: false },
        { hasSignaturePattern: true }
    ],
    agree: false,
    asnefError: false,
    timesTampCheckBox: false,
    agreeError: false,
    confirmationCheckbox: false,
    confirmationCheckboxError: false,
    contractInformationStepOne: null,
    currency: EURO_TEXT,
    downloadError: false,
    error: false,
    errorContractInformationStepOne: false,
    errorDocuments: false,
    errorFormalize: false,
    file: null,
    fileZip: null,
    isFetching: false,
    isFetchingContractInformationStepOne: false,
    isFetchingDocuments: false,
    isFetchingFormalize: false,
    isFetchingZip: false,
    precontractualLink: '',
    success: false,
    visibleStep: WIZARD_FIRST_STEP,
    errorSelectedAccount: false,
    selectedAccount: null,
    selectedAmount: MIN_VALUE_REQUEST_AMOUNT,
    firstEnterInStepTwo: false,
    tinAccount: null,
    taeAccount: null,
    overdraftEmailError: false,
    overdraftEmailLoading: false,
    isOverdraftEmailSent: false,
    initAPIFlag: false,
    mailAPIFlag: false,
    checkboxFlag: false,
    btnFlag: false,
    officePrintStepThree: false,
    officePrintStepFour: false,
    firstSelectedAccount: null,
    firstSelectedAmount: null,
    scrollDown: false, 
    documentSignedRadioButtonStepThree: null,
    documentSignedRadioButtonStepFour: null,
});

const validateStepOne = (state, currentStep, noMail = false, beforeStep) => {
    let validStep = true;
    if (__CONTACT_CENTER__) {
        validStep = !!noMail ? true : !!state.get('confirmationCheckbox');
    }
    const visibleStep = validStep ? currentStep + 1 : currentStep;

    return state
        .setIn(['steps', FIRST_STEP, 'valid'], validStep)
        .setIn(['fourSteps', FIRST_STEP, 'valid'], validStep)
        .merge({
            firstEnterInStepTwo: validStep,
            visibleStep,
            beforeStep,
            confirmationCheckboxError: !validStep,
        });
};

const validateStepTwo = (state, currentStep, beforeStep) => {
    const selectedAccount = state.get('selectedAccount');
    const selectedAmount = state.get('selectedAmount');
    const valid = !!selectedAccount;

    return state
        .setIn(['steps', SECOND_STEP, 'valid'], valid)
        .setIn(['fourSteps', SECOND_STEP, 'valid'], valid)
        .merge({
            firstSelectedAccount: selectedAccount,
            firstSelectedAmount: selectedAmount,
            errorSelectedAccount: !valid,
            visibleStep: valid ? currentStep + 1 : currentStep,
            beforeStep: valid ? beforeStep : state.get('beforeStep')
        });
};
const validateStepThree = (state, currentStep, beforeStep) => {
    const valid =
        isPrintOfficeMode() ? state.get('officePrintStepThree') : state.get('agree');

    return state
        .setIn(['steps', WIZARD_THIRD_STEP - 1, 'valid'], valid)
        .setIn(['fourSteps', WIZARD_THIRD_STEP - 1, 'valid'], valid)
        .merge({
            visibleStep: valid ? currentStep + 1 : currentStep,
            beforeStep: valid ? beforeStep : state.get('beforeStep')
        });
};

const validateStep = (state, action) => {
    const currentStep = action.payload.currentStep;
    const noMail = action.payload.noMail;
    const beforeStep = currentStep;

    if (currentStep === WIZARD_FIRST_STEP) {
        return validateStepOne(state, currentStep, noMail, beforeStep);
    } else if (currentStep === WIZARD_SECOND_STEP) {
        return validateStepTwo(state, currentStep, beforeStep);
    }
    else if (currentStep === WIZARD_THIRD_STEP) {
        return validateStepThree(state, currentStep, beforeStep);
    }
};

const contractPreGrantedCreditReducer = handleActions(
    {
        [simpleActions.contractPreGrantedCreditSetVisibleStep]: (state, action) =>
            state.merge({ visibleStep: action.payload.visibleStep }),
        [simpleActions.contractPreGrantedCreditSetSeletedAccount]: (state, action) =>
            state.merge({
                selectedAccount: action.payload.selectedAccount,
                errorSelectedAccount: false
            }),
        [simpleActions.contractPreGrantedCreditValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.contractPreGrantedCreditGetContractInformation]: state =>
            state.merge({
                isFetchingContractInformationStepOne: true,
                errorContractInformationStepOne: false
            }),
        [simpleActions.contractPreGrantedCreditGetContractInformationError]: state =>
            state.merge({
                isFetchingContractInformationStepOne: false,
                errorContractInformationStepOne: true
            }),
        [simpleActions.contractPreGrantedCreditGetContractInformationSuccess]: (state, action) =>
            state.merge({
                isFetchingContractInformationStepOne: false,
                errorContractInformationStepOne: false,
                contractInformationStepOne: action.payload.response
            }),
        [simpleActions.contractPreGrantedCreditGetPrecontractualSuccess]: (state, action) =>
            state.merge({
                precontractualLink: get(action, 'payload.response.response[0].url', '')
            }),
        [simpleActions.contractPreGrantedCreditAgreeToggle]: (state) =>
            __CONTACT_CENTER__ && !isPrintOfficeMode() ? state.merge({
                confirmationCheckbox: state.get('confirmationCheckbox'),
            }) : state.merge({
                agree: !state.get('agree'),
                timesTampCheckBox: new Date().getTime(),
                agreeError: false
            }),
        [simpleActions.contractPreGrantedCreditOfficePrint]: (state) =>
            state.merge({
                officePrintStepThree: true,
            }),
        [simpleActions.officePrintReset]: (state, action) =>
            state.merge({
                officePrintStepThree: !!action.payload.officePrintStepThree ? true : false,
                officePrintStepFour: !!action.payload.officePrintStepThree ? true : false,
            }),
        [simpleActions.contractPreGrantedCreditOfficeContractPrint]: (state) =>
            state.merge({
                officePrintStepFour: true,
            }),
        [simpleActions.contractPreGrantedCreditAgreeReset]: (state) =>
            __CONTACT_CENTER__ && !isPrintOfficeMode() ?
                state.merge({
                    confirmationCheckbox: !state.get('confirmationCheckbox'),
                    confirmationCheckboxError: false
                }) :
                state.merge({
                    agree: false,
                    agreeError: false
                }),
        [simpleActions.contractPreGrantedCreditDocumentDownload]: (state) =>
            state.merge({
                isFetchingZip: true,
                downloadError: false
            }),
        [simpleActions.contractPreGrantedCreditDocumentDownloadError]: (state) =>
            state.merge({
                isFetchingZip: false,
                downloadError: true
            }),
        [simpleActions.contractPreGrantedCreditDocumentDownloadSuccess]: (state, action) =>
            state.merge({
                isFetchingZip: false,
                fileZip: action.payload.response,
                downloadError: false
            }),
        [simpleActions.contractPreGrantedCreditGetDocument]: (state) =>
            state.merge({
                isFetchingDocuments: true,
                errorDocuments: false
            }),
        [simpleActions.contractPreGrantedCreditGetDocumentError]: (state) =>
            state.merge({
                isFetchingDocuments: false,
                errorDocuments: true
            }),
        [simpleActions.contractPreGrantedCreditGetDocumentSuccess]: (state, action) =>
            state.merge({
                isFetchingDocuments: false,
                file: action.payload.response,
                errorDocuments: false
            }),
        [simpleActions.contractPreGrantedCreditFormalize]: (state) =>
            state.merge({
                isFetchingFormalize: true,
            }),
        [simpleActions.contractPreGrantedCreditFormalizeError]: (state, action) => {
            if (action.payload.response.body.error === "asnef-validation-error") {
                return state.merge({
                    isFetchingFormalize: false,
                    asnefError: true
                });
            } else {
                return state.merge({
                    isFetchingFormalize: false,
                    errorFormalize: true
                });
            }
        },
        [simpleActions.contractPreGrantedCreditFormalizeSuccess]: (state) =>
            state.merge({
                isFetchingFormalize: false,
                errorFormalize: false,
                success: true
            }),
        [simpleActions.contractPreGrantedCreditUpdateConfirmationCheckbox]: state =>
            state.merge({
                confirmationCheckbox: !state.get('confirmationCheckbox'),
                confirmationCheckboxError: false
            }),
        [simpleActions.contractPreGrantedCreditPrecontractualEmail]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: true,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.contractPreGrantedCreditPrecontractualEmailSuccess]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: true,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.contractPreGrantedCreditPrecontractualEmailError]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: true,
            }),
        [simpleActions.contractPreGrantedCreditResetState]: state =>
            state.merge(setInitialState()),
        [simpleActions.contractPreGrantedCreditSetLoanAmount]: (state, action) =>
            state.merge({ selectedAmount: action.payload.selectedAmount }),

        [simpleActions.contractPreGrantedCreditGetIneDocumentSuccess]: (state, action) =>
            state.merge({
                isFetchingINEDocument: false,
                fileINEDocument: `data:application/pdf;base64,${action.payload.base64Document}`,
                fileINEDocumentId: action.payload.temporaryDocumentId,
                errorINEDocument: false
            }),
        [simpleActions.accountTinTaeSuccess]: (state, action) =>
            state.merge({
                accountTinTaeSuccess: true,
                accountTinTaeError: false,
                tinAccount: action.payload.tinAccount,
                taeAccount: action.payload.taeAccount,
            }),
        [simpleActions.accountTinTaeError]: (state) =>
            state.merge({
                accountTinTaeSuccess: false,
                accountTinTaeError: true,
            }),
        [simpleActions.contractPreGrantedCreditGetIneDocument]: (state) =>
            state.merge({
                isFetchingINEDocument: true,
                errorINEDocument: false
            }),
        [simpleActions.contractPreGrantedCreditGetIneDocumentError]: (state) =>
            state.merge({
                isFetchingINEDocument: false,
                errorINEDocument: true
            }),

        [simpleActions.contractPreGrantedCreditGetDraftDocumentSuccess]: (state, action) =>
            state.merge({
                isFetchingDraftDocument: false,
                fileDraftDocument: action.payload.flag ? `data:application/pdf;base64,${action.payload.base64Document}` : action.payload.response,
                contractDocumentId: action.payload.flag && action.payload.temporaryDocumentId,
                errorDraftDocument: false,
                successDraftDocument: true
            }),
        [simpleActions.contractPreGrantedCreditGetDraftDocument]: (state) =>
            state.merge({
                isFetchingDraftDocument: true,
                errorDraftDocument: false,
                successDraftDocument: false
            }),
        [simpleActions.contractPreGrantedCreditGetDraftDocumentError]: (state) =>
            state.merge({
                isFetchingDraftDocument: false,
                errorDraftDocument: true,
                successDraftDocument: false
            }),
        [simpleActions.contractOverdraftEmailLoading]: state =>
            state.merge({
                isOverdraftEmailSent: false,
                overdraftEmailError: false,
                overdraftEmailLoading: true
            }),
        [simpleActions.contractOverdraftEmailSuccess]: state =>
            state.merge({
                isOverdraftEmailSent: true,
                overdraftEmailError: false,
                overdraftEmailLoading: false
            }),
        [simpleActions.contractOverdraftEmailError]: state =>
            state.merge({
                isOverdraftEmailSent: false,
                overdraftEmailError: true,
                overdraftEmailLoading: false
            }),
        [simpleActions.resetMailSent]: state =>
            state.merge({
                isOverdraftEmailSent: false,
                overdraftEmailError: false,
                overdraftEmailLoading: false
            }),
        [simpleActions.contractPreGrantedCreditOverDraftInitLoading]: state =>
            state.merge({
                isOverdraftEmailInitError: false,
                isOverdraftEmailInitSuccess: false
            }),
        [simpleActions.contractPreGrantedCreditOverDraftInitOneSuccess]: (state, action) =>
            state.merge({
                isOverdraftEmailInitError: false,
                isOverdraftEmailInitSuccess: true,
                operationProcessIdINE: action.payload.operationProcessIdINE
            }),
        [simpleActions.contractPreGrantedCreditOverDraftInitTwoSuccess]: (state, action) =>
            state.merge({
                isOverdraftEmailInitError: false,
                isOverdraftEmailInitSuccess: true,
                operationProcessIdPolicy: action.payload.operationProcessIdPolicy
            }),
        [simpleActions.contractPreGrantedCreditOverDraftInitError]: state =>
            state.merge({
                isOverdraftEmailInitError: true,
                isOverdraftEmailInitSuccess: false
            }),
        [simpleActions.setInitApiFlag]: (state, action) =>
            state.merge({
                initAPIFlag: action.payload.initFlag,
                mailAPIFlag: action.payload.mailFlag,
                checkboxFlag: action.payload.checkboxFlag,
                btnFlag: action.payload.btnFlag,
            }),
        [simpleActions.contractPreGrantedCreditReadDocument]: (state) =>
            state.set('scrollDown', true),
        [simpleActions.contractPreGrantedCreditCheckRadioButtonStepFour]: (state, action) => 
            state.merge({
                documentSignedRadioButtonStepFour: action.payload,
            }),
        [simpleActions.contractPreGrantedCreditCheckRadioButtonStepThree]: (state, action) => 
            state.merge({
                documentSignedRadioButtonStepThree: action.payload,
            }),
    },
    setInitialState()
);

module.exports = contractPreGrantedCreditReducer;
module.exports.setInitialState = setInitialState;
